module.exports = __webpack_public_path__ + "img/add-doc.bdce5509.svg";